import React, { useState } from "react";
import { Button, Dropdown, Menu } from "antd";
import { ReactComponent as FilterIcon } from "../../../assets/Icons/filterIcon.svg";
import EllipsisTooltip from "../../EllipsisTooltip/EllipsisTooltip";
import "./CustomFilterDropdown.scss";

const CustomFilterDropdown = ({
  buttonLabel = "Category",
  options = [],
  onChange,
  defaultValue = null,
}) => {
  const [selectedValue, setSelectedValue] = useState(defaultValue);
  const [isOpen, setIsOpen] = useState(false);

  const handleMenuClick = (e) => {
    const value = e.key;
    setSelectedValue(value);
    onChange?.(value);
    setIsOpen(false); // close after selection
  };

  const menu = (
    <Menu
      className="custom-dropdown-menu"
      onClick={handleMenuClick}
      selectedKeys={[selectedValue]}
      items={options.map((item) => ({
        key: item.value,
        label: <EllipsisTooltip text={item.label || ""} />,
      }))}
    />
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={["click"]}
      overlayClassName="custom-dropdown-wrapper"
      onOpenChange={(open) => setIsOpen(open)}
    >
      <Button className={`dropdown-button ${isOpen ? "active" : ""}`}>
        <FilterIcon className="filter-icon" />
        <span>{buttonLabel}</span>
      </Button>
    </Dropdown>
  );
};

export default CustomFilterDropdown;

